var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_c('v-list-item',{staticClass:"list-item",on:{"click":_vm.logout}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("fas fa-power-off")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Salir")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }